/**
 * Product Tabs Section
 * 
 * Handles:
 * 1. Tab switching functionality
 * 2. Product slider controls
 * 3. Responsive behavior
 */
class ProductTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('.section-product-tabs__nav-item');
    this.panels = this.querySelectorAll('.section-product-tabs__panel');
    this.sliders = this.querySelectorAll('.slider');
    this.prevButtons = this.querySelectorAll('.slider-button--prev');
    this.nextButtons = this.querySelectorAll('.slider-button--next');
    
    this.init();
  }
  
  init() {
    // Tab switching
    this.tabs.forEach(tab => {
      tab.addEventListener('click', this.switchTab.bind(this));
    });
    
    // Slider controls
    this.initSliders();
    
    // Handle resize events for responsive adjustments
    window.addEventListener('resize', this.handleResize.bind(this));
    
    // Initial resize handler call to set up correct sizes
    this.handleResize();
  }
  
  switchTab(event) {
    const selectedTab = event.currentTarget;
    const tabIndex = selectedTab.dataset.tabIndex;
    
    // Update active state for tabs
    this.tabs.forEach(tab => {
      tab.classList.remove('active');
      tab.setAttribute('aria-selected', 'false');
    });
    selectedTab.classList.add('active');
    selectedTab.setAttribute('aria-selected', 'true');
    
    // Update active state for panels
    this.panels.forEach(panel => {
      panel.classList.remove('active');
    });
    
    const targetPanel = this.querySelector(`[data-tab-panel="${tabIndex}"]`);
    if (targetPanel) {
      targetPanel.classList.add('active');
      
      // Reset scroll position of slider when switching tabs
      const slider = targetPanel.querySelector('.slider');
      if (slider) {
        slider.scrollLeft = 0;
      }
    }
  }
  
  initSliders() {
    // Initialize next/prev buttons
    this.prevButtons.forEach((button, index) => {
      button.addEventListener('click', () => this.slideProducts('prev', index));
    });
    
    this.nextButtons.forEach((button, index) => {
      button.addEventListener('click', () => this.slideProducts('next', index));
    });
    
    // Add touch swiping support
    this.sliders.forEach(slider => {
      let startX, scrollLeft, isDown = false;
      
      slider.addEventListener('mousedown', (e) => {
        isDown = true;
        slider.style.cursor = 'grabbing';
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
        e.preventDefault();
      });
      
      slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.style.cursor = 'grab';
      });
      
      slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.style.cursor = 'grab';
      });
      
      slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2; // Scroll speed
        slider.scrollLeft = scrollLeft - walk;
      });
    });
  }
  
  slideProducts(direction, sliderIndex) {
    const activePanel = this.querySelector('.section-product-tabs__panel.active');
    if (!activePanel) return;
    
    const slider = activePanel.querySelector('.slider');
    if (!slider) return;
    
    const slideWidth = slider.querySelector('.slider__slide').offsetWidth + 20; // Adding gap
    const scrollAmount = direction === 'next' ? slideWidth : -slideWidth;
    
    slider.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });
  }
  
  handleResize() {
    // Update slide widths based on viewport
    const viewportWidth = window.innerWidth;
    
    this.sliders.forEach(slider => {
      const slides = slider.querySelectorAll('.slider__slide');
      let slidesPerView = 1; // Default for mobile
      
      if (viewportWidth >= 1200) {
        slidesPerView = 4; // Desktop
      } else if (viewportWidth >= 990) {
        slidesPerView = 3; // Tablet landscape
      } else if (viewportWidth >= 750) {
        slidesPerView = 2; // Tablet portrait
      }
      
      // Check if scrollbar should be visible
      const totalSlides = slides.length;
      if (totalSlides <= slidesPerView) {
        // Hide controls if all slides fit
        const controls = slider.closest('.slider-component').querySelector('.slideshow__controls');
        if (controls) {
          controls.style.display = 'none';
        }
      } else {
        // Show controls if not all slides fit
        const controls = slider.closest('.slider-component').querySelector('.slideshow__controls');
        if (controls) {
          controls.style.display = 'flex';
        }
      }
    });
  }
}

// Register custom element
customElements.define('product-tabs', ProductTabs);

// Initialize existing product tab sections on page
document.addEventListener('DOMContentLoaded', () => {
  // Find all product tab sections and initialize them
  const productTabSections = document.querySelectorAll('.section-product-tabs');
  productTabSections.forEach(section => {
    const tabs = section.querySelectorAll('.section-product-tabs__nav-item');
    const panels = section.querySelectorAll('.section-product-tabs__panel');
    
    if (!tabs.length || !panels.length) return;
    
    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const tabIndex = this.getAttribute('data-tab-index');
        
        // Toggle active state for tabs
        tabs.forEach(t => t.classList.remove('active'));
        this.classList.add('active');
        
        // Toggle active state for panels
        panels.forEach(panel => panel.classList.remove('active'));
        section.querySelector(`[data-tab-panel="${tabIndex}"]`).classList.add('active');
      });
    });
  });
}); 
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.section-product-tabs .custom-card__variant-select')
    .forEach(el => {
      ['mousedown','touchstart','pointerdown','click'].forEach(evt => {
        el.addEventListener(evt, e => e.stopPropagation(), { capture: true });
      });
    });
});